<script setup lang="ts">
defineOptions({ inheritAttrs: false });

import { ref, computed, watch } from "vue";

interface Panel {
  name: string;
  label: string;
  disabled: boolean;
}

const active = ref();
const props = withDefaults(
  defineProps<{
    panels: Panel[];
    defActive?: string;
    animatedTime: number;
    fixedHeight?: boolean;
  }>(),
  { fixedHeight: false }
);
const emit = defineEmits(["change"]);

watch(
  () => props.defActive,
  (val) => {
    active.value = val;
    if (val) {
      emit("change", val);
    }
  },
  { immediate: true }
);

const innerAnimatedTime = computed(() =>
  props.fixedHeight ? 0 : props.animatedTime
);

function setActive(val: string) {
  if (active.value === val) return;
  active.value = val;
  emit("change", val);
}

function onChange(args: any) {
  emit("change", args.paneKey);
}

defineExpose({ setActive });
</script>
<template>
  <nut-tabs
    class="mp-tabs"
    :class="{ fixedHeight }"
    v-model="active"
    v-bind="$attrs"
    :animatedTime="innerAnimatedTime"
    @change="onChange"
  >
    <nut-tab-pane
      v-for="(panel, index) in panels"
      :key="index"
      :pane-key="panel.name"
      :title="panel.label"
    >
      <slot :name="panel.name" />
    </nut-tab-pane>
  </nut-tabs>
</template>
<style lang="scss">
.mp-tabs {
  .nut-tab-pane {
    padding: 2px !important;
  }
}

.mp-tabs.horizontal.fixedHeight {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  .nut-tabs__content {
    flex: 1;
    overflow: hidden;

    .nut-tab-pane {
      height: 100%;
    }
  }
}

.mp-tabs.vertical {
  height: 100%;
}
</style>
